import React, { useEffect, useRef } from 'react';
import { useFloatingVideo } from '../contexts/FloatingVideoContext';
import Avatar from './Avatar';
import './FloatingVideoPlayer.css';

const FloatingVideoPlayer = () => {
  const { floatingVideo, deactivateFloatingVideo, updateVideoTime } = useFloatingVideo();
  const videoRef = useRef(null);

  useEffect(() => {
    if (floatingVideo && videoRef.current) {
      videoRef.current.currentTime = floatingVideo.currentTime || 0;
      videoRef.current.play().catch(err => console.error('Error playing video:', err));
    }
  }, [floatingVideo]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      updateVideoTime(video.currentTime);
    };

    video.addEventListener('timeupdate', handleTimeUpdate);
    return () => video.removeEventListener('timeupdate', handleTimeUpdate);
  }, [updateVideoTime]);

  if (!floatingVideo) return null;

  // Helper function to truncate caption to 10 words
  const truncateCaption = (text) => {
    if (!text) return '';
    const words = text.trim().split(/\s+/);
    if (words.length <= 10) return text;
    return words.slice(0, 10).join(' ') + '...';
  };

  const handleClose = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    deactivateFloatingVideo();
  };

  const handleReturnToPost = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    deactivateFloatingVideo();
    // Scroll to the original post element if it exists
    const postElement = document.getElementById(`post-${floatingVideo.postId}`);
    if (postElement) {
      postElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div className="floating-video-player">
      <div className="floating-video-header">
        <div className="floating-video-info" onClick={handleReturnToPost}>
          <Avatar
            src={floatingVideo.author?.avatarUrl}
            alt={floatingVideo.author?.displayName || floatingVideo.author?.username}
            size="small"
          />
          <div className="floating-video-author">
            <span>{truncateCaption(floatingVideo.caption)}</span>
          </div>
        </div>
        <button className="floating-video-close" onClick={handleClose}>
          ×
        </button>
      </div>
      <div className="floating-video-container" onClick={handleReturnToPost}>
        <video
          ref={videoRef}
          src={floatingVideo.url}
          controls
          playsInline
          className="floating-video"
        />
      </div>
    </div>
  );
};

export default FloatingVideoPlayer;
